require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-members-of-congress-call-for-world-bank-to-suspend.json") })
        }
      }, "path---en-us-update-members-of-congress-call-for-world-bank-to-suspend");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-members-of-congress-call-for-world-bank-to-suspend!./.cache/json/en-us-update-members-of-congress-call-for-world-bank-to-suspend.json
// module id = 774
// module chunks = 231608221292675